<template>
  <div>
    <div class="titlebar h-16 bg-gray-300 flex justify-between fixed top-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/back.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        Post Title (Detail Page)
      </div>
      <div class="flex justify-center items-center mr-5">
        <img class="cursor-pointer" @click="$router.push('/app/home')" src="../ics/close.svg" alt="">
      </div>
    </div>

    <div class="h-16"></div>

    <div class="max-w-xl mx-auto" v-if="post">
      <Post :detail="false" :post="post"></Post>

      <LoaderUI2 class="mt-5 mb-5" v-if="!post"></LoaderUI2>

      <CommentsArea :post="post"></CommentsArea>
    </div>

    <LeftMenu></LeftMenu>

    <!-- <div class="h-16"></div>
    <div class="bottombar h-16 bg-gray-300 flex justify-between fixed bottom-0 left-0 w-full">
      <div class="flex justify-center items-center ml-5">
        <img src="../ics/plus.svg" alt="">
      </div>
      <div class="flex justify-center items-center">
        <img src="../ics/bell.svg" alt="">
      </div>
      <div class="flex justify-center items-center mr-5">
        <img src="../ics/reload.svg" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
import { state as AppState } from '../../api/api.js'
import Post from '../../api/posts.js'
import { Base64 } from '../../api/util'

export default {
  components: {
    LoaderUI2: require('../uis/LoaderUI2.vue').default,
    LeftMenu: require('../uis/LeftMenu.vue').default,
    CommentsArea: require('../uis-post/CommentsArea.vue').default,
    Post: require('../uis-post/Post.vue').default
  },
  data () {
    return {
      PostState: Post.state,
      post: false
    }
  },
  computed: {
    postID () {
      return Base64.decode(decodeURIComponent(this.$route.params.postID))
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    async load () {
      this.post = await Post.providePostByPostID({ postID: this.postID, userID: AppState.me.user._id })
      console.log(this.post)
    }
  }
}
</script>

<style>

</style>
